export const primaryThemeColors = {
  primary: "#FAB72B",
  secondary: "#6CBADF",
  white: "#FCFCFC",
  gray: "#6E6353",
  dark: "#41392E",
  textColor: "#41392E",
  hoverTextColor: "#776D5E",
  lightTextColor: "#41392e88",

  secondTextColor: "#fff",
  thirdTextColor: "#040a1e", //"#333",
  red: "#f00",
  cardTextColor: "#040a1e",
  secondGray: "#aaa",
  headerColor: "#040a1e", //"#050505",
  subTitleColor: "#040a1e", //"#080f25",
  lightLavender: "#EEF0FA",
  softBlue: "#B0C6EB",
  pureWhite: "#FFFFFF",
  paleYellow: "#FFFF7E",
};
